import { EventTriggerType, EventTriggerTypeCloudProcessable } from "@app/shared";

// Trigger types that CoreApi can evaluate in the cloud (ProcessOnDevice = false). Each of these has a
// registered, implemented server-side detector fed by data the server produces during target ingestion
// (ScreenLineChange / DetectionZoneChange facility events, or the target rows themselves).
//
// Every other trigger type is edge-only: the firmware implements all detectors, but the server either
// stubs them (WrongWay / NearMiss return false), throws (DetectionZoneDwell), never registers the
// detector (DetectionZonePresence), or has no server detector at all (ImpendingZoneEntry / LaneLine).
// For those, ProcessOnDevice must stay on, so we don't expose the toggle.
//
// The set itself is GENERATED, not maintained here: it comes from the [CloudProcessable] attributes on the
// EventTriggerType members in Shared/Models/Api/v1/EventTriggers/EventTrigger.cs, which CoreApi also
// reads (via EventTriggerCapabilities) to pin ProcessOnDevice = true on save and on device-originated
// facility sync. Re-exported under a local name only so the call sites here read in domain terms — do
// not replace it with a literal list, or the server and the editor can disagree again.
export const CLOUD_CAPABLE_TRIGGER_TYPES: ReadonlySet<EventTriggerType> = EventTriggerTypeCloudProcessable;

export const isCloudProcessingSupported = (type: EventTriggerType | undefined): boolean =>
    type !== undefined && CLOUD_CAPABLE_TRIGGER_TYPES.has(type);
